import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { atom, useAtomValue } from 'jotai';

import { css } from '@flipster/styled-system/css';

import { SymbolScope } from '../../../../shared/symbol/bunja';
import { instrumentBunja } from '../../../state/base';

export const SymbolIcon = () => {
  const { srcAtom, alt } = useBunja(symbolIconBunja);
  const src = useAtomValue(srcAtom);
  return (
    <div className={css({ w: 32, h: 32, lineHeight: 0 })}>
      {src && <img className={css({ w: '100%' })} src={src} alt={alt} />}
    </div>
  );
};

const symbolIconBunja = bunja(() => {
  const symbol = bunja.use(SymbolScope);
  const { instrumentAtom } = bunja.use(instrumentBunja);
  const srcAtom = atom((get) => get(instrumentAtom)?.icon);
  const alt = symbol;
  return { srcAtom, alt };
});
symbolIconBunja.debugLabel = 'symbolIconBunja';
